<template>
  <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
    <div class="boxShadow setBorderRadius heig-frame-equipment-group">
      <b-row no-gutters>
        <b-col md="12" class="heig-frame-child">
          <gofix-card title=" ">
            <b-row>
              <b-col md="3">
                <gofix-form-input label="UEN" v-model="qr.uen" required showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="3">
                <gofix-form-input label="Amount" v-model="qr.amount" required showIconRequired></gofix-form-input>
              </b-col>
              <b-col md="3">
                <gofix-form-input label="Reference Number" v-model="qr.ref_number"></gofix-form-input>
              </b-col>
              <b-col md="3">
                <gofix-form-input label="Company" v-model="qr.company"></gofix-form-input>
              </b-col>
              <b-col md="12" v-if="qrImage">
                <img :src="qrImage" alt="" class="mb-3">
              </b-col>
              <b-col md="12">
                <div class="d-flex justify-content-start align-items-center">
                  <gofix-button @click="invokePayment" :loading="loading" :disabled="!$checkRole(this.$accessModule.uob_generate_qr, 'create') && !$checkRole(this.$accessModule.uob_generate_qr, 'update')"
                                label="Generate QR Code Image"></gofix-button>
                </div>
              </b-col>
            </b-row>
          </gofix-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'uob_generate_qr',
  data() {
    return {
      loading: false,
      qr: {
        uen: "198803538NGFX",
        ref_number: null,
        amount: null,
        company: null,
      },
      qrImage: null
    }
  },
  computed: {},
  watch: {},
  async created() {

  },
  methods: {
    invokePayment() {
      //Check required data
      if (!this.qr.amount || !this.qr.uen) {
        return this.$bvToast.toast("Please fill all required fields", {
          title: `Notification`,
          autoHideDelay: 3000,
          variant: 'danger',
          solid: true
        })
      }

      //Generate QR
      this.loading = true;
      this.$store.dispatch("UOBController/generateQr", this.qr)
          .then(response => {
            this.loading = false;
            this.qrImage = response;
          })
          .catch(err => {
            this.loading = false;
            this.qrImage = null;
            return this.$bvToast.toast("Can't generate qr code!", {
              title: `Notification`,
              autoHideDelay: 3000,
              variant: 'danger',
              solid: true
            })
          })
    },
  }
}
</script>
